import { Outlet } from "react-router-dom";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import FloatingCTA from "@/components/layout/FloatingCTA";
import SmoothScroll from "@/components/SmoothScroll";
import { localBusinessSchema } from "@/lib/schema";
import { useEffect } from "react";

export default function Layout() {
  // Inject global LocalBusiness schema once
  useEffect(() => {
    const s = document.createElement("script");
    s.type = "application/ld+json";
    s.setAttribute("data-global-schema", "true");
    s.textContent = JSON.stringify(localBusinessSchema());
    document.head.appendChild(s);
    return () => s.remove();
  }, []);

  return (
    <SmoothScroll>
      <div className="min-h-screen bg-brand-obsidian text-white">
        <Header />
        <main className="pb-16 md:pb-0">
          <Outlet />
        </main>
        <Footer />
        <FloatingCTA />
      </div>
    </SmoothScroll>
  );
}
